export const selectOrgConfig = ({ orgConfig }) => orgConfig;
